import React, { Component, PropTypes } from 'react';
import './Loader.scss';

export class Loader extends Component {

    constructor(props) {
        super(props);
        this.state = {}
    };

    render() {
        return (
            <div className="email-container">

        
              <div className='email-loader'>
                <div className='loader_cogs'>
                <div className='loader_cogs__top'>
                  <div className='top_part'></div>
                  <div className='top_part'></div>
                  <div className='top_part'></div>
                  <div className='top_hole'></div>
                </div>
                <div className='loader_cogs__left'>
                  <div className='left_part'></div>
                  <div className='left_part'></div>
                  <div className='left_part'></div>
                  <div className='left_hole'></div>
                </div>
                <div className='loader_cogs__bottom'>
                  <div className='bottom_part'></div>
                  <div className='bottom_part'></div>
                  <div className='bottom_part'></div>
                  <div className='bottom_hole'></div>
                </div>
                </div>

              </div>


            </div>
        );
    }
}

export default Loader;



// WEBPACK FOOTER //
// ./src/views/components/Loader/index.js